import classNames from 'classnames';
import React from 'react';

import {ConstraintSource} from 'constants/RegistryConstants';
import {SchemaInterfaceTooltip} from 'schemas/schema-interface/SetBySchemaInterfaceTooltip';

import {ConstraintTableType} from './ConstraintTable';
import TagSchemaFieldChip from './TagSchemaFieldChip';

export interface TagSchemaConstraintProps {
  className?: string;
  fields: Array<string | undefined>;
  source: ConstraintSource | null;
  tableType: ConstraintTableType;
}

function ConstraintSourceTooltip({source}: {source: ConstraintSource | null}): JSX.Element | null {
  if (source) {
    return (
      <SchemaInterfaceTooltip
        schemaInterfaceIdAndName={source}
        textBefore="Requires uniqueness across all the schemas in the"
      />
    );
  }
  return null;
}

function TagSchemaConstraint({
  className,
  fields,
  source,
  tableType,
}: TagSchemaConstraintProps): JSX.Element | null {
  const constraintDescriptionPrefix = fields.length === 1 ? 'Unique ' : 'Unique combination of ';
  return fields.length === 0 ? null : (
    <div className="simpleDivTable-row">
      <div className={classNames(className, 'simpleDivTable-cell', 'u-flex-display')}>
        <span className="u-tiny-spacing-right u-valign-middle">{constraintDescriptionPrefix}</span>
        <span className="u-tiny-spacing-right">
          {tableType === ConstraintTableType.SCHEMA && <ConstraintSourceTooltip source={source} />}
        </span>
        {fields.map((field: string, i: number) => (
          <TagSchemaFieldChip key={i} name={field} />
        ))}
      </div>
    </div>
  );
}

export default TagSchemaConstraint;
